import { faEnvelope } from '@awesome.me/kit-3777c2145e/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import autobind from 'autobind-decorator';
import React from 'react';
import { FormTextInput } from '../FormTextInput/FormTextInput.js';
import { validEmailAddress } from './FormEmail.fn.js';

function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
class FormEmail extends FormTextInput {
    handleValidate(email, allValues) {
        if (email) {
            const error = validEmailAddress(email);
            if (error) {
                return error;
            }
        }
        return super.handleValidate(email, allValues);
    }
    getInputProps(fieldProps) {
        const { id, name, autoComplete } = this.props;
        const { input: { value = "" } } = fieldProps;
        const itemId = id || name + this.id;
        if (autoComplete === "off" || !value?.includes("@")) {
            return {
                ...super.getInputProps(fieldProps),
                type: "email"
            };
        }
        return {
            ...super.getInputProps(fieldProps),
            type: "email",
            list: `${itemId}-dataList`
        };
    }
    renderDataList(dataListId, dataList, value) {
        const { autoComplete } = this.props;
        if (dataList) {
            return super.renderDataList(dataListId, dataList, value);
        }
        if (autoComplete === "off" || typeof value !== "string" || !value.includes("@")) {
            return null;
        }
        const typed = `${value}`.split("@")[0];
        const domains = [
            "@gmail.com",
            "@freemail.hu",
            "@icloud.com",
            "@hotmail.com",
            "@citromail.hu"
        ];
        return /*#__PURE__*/ React.createElement("datalist", {
            id: dataListId
        }, domains.map((item)=>/*#__PURE__*/ React.createElement("option", {
                key: item,
                value: typed + item
            })));
    }
}
FormEmail.defaultProps = {
    prepend: /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
        icon: faEnvelope
    }),
    autoComplete: "email"
};
_ts_decorate([
    autobind,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Object)
], FormEmail.prototype, "handleValidate", null);

export { FormEmail };
//# sourceMappingURL=FormEmail.js.map
